import { createContext, useContext } from 'react';
export const GridContext = createContext({
    availableColumns: 12,
});
export const useGridContext = () => useContext(GridContext);
